import { Card, Typography } from '@mui/material';

export default function LockedMessage() {
  return (
    <Card sx={{ width: '100%', marginBottom: '2rem' }}>
      <Typography
        sx={{
          textAlign: 'center',
          fontSize: '1.25rem',
          m: '2rem',
          fontWeight: 600,
          textTransform: 'uppercase',
        }}
      >
        The System is currently locked. Please try again later.
      </Typography>
    </Card>
  );
}
